import { render, staticRenderFns } from "./whatsappCampaigns.vue?vue&type=template&id=747fd4fa&"
import script from "./whatsappCampaigns.vue?vue&type=script&lang=js&"
export * from "./whatsappCampaigns.vue?vue&type=script&lang=js&"
import style0 from "./whatsappCampaigns.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "whatsappCampaigns.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {
  VCard,
  VFlex,
  VIcon,
  VLayout,
  VProgressCircular,
  VTooltip,
})
